import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import isoWeek from "dayjs/plugin/isoWeek";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(customParseFormat); // Necessary for date validation to work correctly
dayjs.extend(isBetween);
dayjs.extend(isoWeek); // Makes week start on Monday instead of Sunday
dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(utc);

dayjs.utc();

export const today = dayjs().startOf("day");
export const yesterday = today.subtract(1, "day");

export { dayjs, Dayjs };
